import request from '@/utils/request'

export function listOnRoad(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/check/listOnRoad',
    method: 'get',
    params
  })
}

export function createOnRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/check/createOnRoad',
    method: 'post',
    data
  })
}

// 详情
export function detailOnRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/detailOnRoad/${id}`,
    method: 'get'
  })
}

// 更新
export function updateOnRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/updateOnRoad`,
    method: 'put',
    data
  })
}

// 删除
export function deleteOnRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/deleteOnRoad/${id}`,
    method: 'delete'
  })
}

// 审核
export function checkOnRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/checkOnRoad`,
    method: 'put',
    data
  })
}

// 非道路列表
export function listOffRoad(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/check/listOffRoad',
    method: 'get',
    params
  })
}

// 新增非道路
export function createOffRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/check/createOffRoad',
    method: 'post',
    data
  })
}

// 非道路详情
export function detailOffRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/detailOffRoad/${id}`,
    method: 'get'
  })
}

// 更新非道路
export function updateOffRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/updateOffRoad`,
    method: 'put',
    data
  })
}

// 删除非道路
export function deleteOffRoad(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/deleteOffRoad/${id}`,
    method: 'delete'
  })
}

// 审核非道路
export function checkOffRoad(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/checkOffRoad`,
    method: 'put',
    data
  })
}

// 安全检验报告列表
export function listSecurity(params) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/check/listSecurity',
    method: 'get',
    params
  })
}

// 创建安全检验报告
export function createSecurity(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: '/check/createSecurity',
    method: 'post',
    data
  })
}

// 安全检验报告详情
export function detailSecurity(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/detailSecurity/${id}`,
    method: 'get'
  })
}

// 更新安全检验报告
export function updateSecurity(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/updateSecurity`,
    method: 'put',
    data
  })
}

// 删除安全检验报告
export function deleteSecurity(id) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/deleteSecurity/${id}`,
    method: 'delete'
  })
}

// 审核安全检验报告
export function checkSecurity(data) {
  return request({
    baseURL: process.env.VUE_APP_API,
    url: `/check/checkSecurity`,
    method: 'put',
    data
  })
}
